import React from "react";
import { DivFale } from "./style";
import Logo from '../img/img_logoEPC_medio.png'



export const FaleConosco = () => {

    return (

        <DivFale>

            <div className="blocos">

                <div className="bloco-01">
                    <h1>FALE CONOSCO
                        <div className="traco"></div>
                    </h1>

                    <div>
                        <img src={Logo} alt="imagem da logo etiquetapontocom" />
                    </div>

                    
                        <div className="mapa">
                            <iframe                            
                            title="Mapa da localização da empresa"
                            src="https://www.google.com/maps?q=Rua+Diamantina,+576,+Vila+Maria,+São+Paulo,+SP,+Brasil&output=embed"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            loading="lazy"
                            allowFullScreen
                            />                
                        </div>

                    
                </div>

                <div className="bloco-02">
                    <h2 > ENDEREÇO </h2>
                    <h3 >Rua Diamantina, 576 <br />Vila Maria Baixa<br />
                        CEP 02117-011 - São Paulo - SP<br />Brasil</h3>

                    <h2> E-MAIL </h2>
                    <h3>etiqueta@etiquetapontocom.net </h3>

                    <h2> TELEFONE </h2>
                    <h3>(11) - 2227-7810 </h3>

                    <h2> WHATsAPP </h2>
                    <h3>(11) 9.8174-3283</h3>

                </div>

                <div className="bloco-03">
                    <div className="fundo-lateral"></div>
                </div>

            </div>

        </DivFale>
    )
}